import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";

export const InvitePartner = async (data: any) => {
  try {
    const response = await apiClient.post(
      "/partnerInvites/sendInvitation",
      data,
    );
    return response;
  } catch (error) {
    handleError(error);
  }
};

export const getPartnerInvitationsList = async (
  search: string | number | undefined,
  status: string,
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `partnerInvites/partnersList?status=${status}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const invitePartnerToJob = async (data: any) => {
  try {
    const response = await apiClient.post(
      "/partnerJobs/invitePartnerToJob",
      data,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getJobPartnersList = async (jobId: any) => {
  try {
    const response = await apiClient.get(
      `/partnerJobs/jobPartnersList?jobId=${jobId}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAcceptedPartnersWithSkillMatch = async (
  jobId: any,
  matchedToJobSkill: boolean,
  search: string,
  currentPage: number,
  pageSize: number,
  city: string[],
  state: string[],
) => {
  try {
    const response = await apiClient.get(
      "/partnerJobs/getAcceptedPartnersWithSkillMatch",
      {
        params: {
          jobId,
          matchedTojobSkill: matchedToJobSkill,
          currentPage,
          pageSize,
          search,
          city: JSON.stringify(city), // <-- key part
          state: JSON.stringify(state), // <-- key part
        },
      },
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// create or draft contract
export const createSaveContract = async (data: any) => {
  try {
    const response = await apiClient.post("contracts/createContract", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// get contract list
export const getContractList = async (
  search: string | number | undefined,
  status: string,
  vendorId: string,
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `contracts/getContractList?status=${status}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}&vendorId=${vendorId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// getContractVendors for filter
export const getContractVendors = async (search: string) => {
  try {
    const response = await apiClient.get(
      `contracts/getContractVendors?search=${search}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// getContractDetails
export const getContractDetails = async (jobcontractId: any) => {
  try {
    const response = await apiClient.get(
      `contracts/getContractDetails?jobcontractId=${jobcontractId}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// get partner's location list for filter
export const getPartnerLocationList = async () => {
  try {
    const response = await apiClient.get("partnerInvites/getPartnersLocation");
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// Get contract details api
export const getContractDetailsById = async (contractId: any) => {
  try {
    const res = await apiClient.get(
      `contracts/getContractInfo?jobcontractId=${contractId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// Application Api
export const getCompanyApplications = async (
  search: string | number | undefined,
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `jobs/getCompanyApplications?search=${search}&currentPage=${currentPage}&pageSize=${pageSize}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
// get documentation API
export const getUploadedDocuments = async (partnerCompanyId: any) => {
  try {
    const res = await apiClient.get(
      `partnerInvites/partnersUploadedDocuments?partnerCompanyId=${partnerCompanyId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// get resource document API
export const getResourceDocument = async (
  search: string | number | undefined,
  partnerCompanyId: any,
  jobId: any,
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `partnerInvites/resourceUploadedDocuments?partnerCompanyId=${partnerCompanyId}&jobId=${jobId}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// get partnerJobs for resource filter

export const partnerJobsList = async (partnerCompanyId: string) => {
  try {
    const res = await apiClient.get(
      `partnerJobs/list?partnerCompanyId=${partnerCompanyId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
